import { PLUGIN_ID } from '../pluginId';

/** Build a fully-qualified translation key under this plugin's namespace. */
export const getTrad = (id: string): string => `${PLUGIN_ID}.${id}`;

/**
 * Namespace a flat `{ key: value }` translation map under the plugin id.
 * Replaces the v4 `prefixPluginTranslations` helper (no longer exported by
 * `@strapi/strapi/admin` in Strapi v5).
 */
export const prefixPluginTranslations = (
  trad: Record<string, string>,
  pluginId: string
): Record<string, string> => {
  if (!pluginId) {
    throw new TypeError("pluginId can't be empty");
  }
  return Object.keys(trad).reduce<Record<string, string>>((acc, current) => {
    acc[`${pluginId}.${current}`] = trad[current];
    return acc;
  }, {});
};
